import React from 'react';
import moment from 'moment';

import { Link } from 'react-router-dom'

import {List, ListItem} from 'material-ui/List';
import Checkbox from 'material-ui/Checkbox';

function lastConnection(_date) {
    if( !!_date && _date.trim() !== "" ) {
        return moment(_date, "YYYY-MM-DD hh:mm:ss").add(2, 'h').fromNow() + "|" + _date;
    } else {
        return "Cliente no conectado aun";
    }
}

const TableClients = ({clients}) => (
    <List id="listClients">
        {
            clients.map((row, index) => (
                <ListItem key={index}
                    leftCheckbox={<Checkbox />}
                    primaryText={<Link to={`/clientdetails/${row.clientID}`}>{row.clientName}</Link>}
                    secondaryText={lastConnection(row.lastConnection)}
                />
            )) 
        }
    </List>
);
export default TableClients;

/*
var q = document.getElementById("listClients");
q.querySelector("label");
q.querySelectorAll("label");

var w = q.querySelectorAll("label");
for(var i = 0; i<w.length; i++) w[i].click()

var e = q.querySelectorAll("label")[0]
e.querySelector("input")
var r = e.querySelector("input")

r.checked

document.getElementById("listClients").querySelectorAll("label").forEach((item, index) => {
    if(!item.querySelector("input").checked) {
        item.click();
    }
});

var qwe = []
document.getElementById("listClients").querySelectorAll("label").forEach((item, index) => {
    if(item.querySelector("input").checked) {
        qwe.push(index);
    }
});
*/





// WEBPACK FOOTER //
// ./src/components/MainComponents/TableClients.js